module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/02-a9b2ec565e1850c7dd8787d5f44ebb05.jpg";